export const convertPrice = (product, currency) => {
    if (currency === "CAD") {
        return product.cadPrice
    } else {
        return product.price
    }
}

export const convertPriceId = (product, currency) => {
    if (currency === "CAD") {
        return product.cadPriceId
    } else {
        return product.priceId
    }
}

export const currencySymbol = (currency) => {
    if (currency === "CAD") {
        return "C$"
    } else {
        return "$"
    }
}

